import { useMutation } from "@apollo/client";
import { createContext, useContext, useEffect, useState } from "react";
import { redirect } from 'react-router-dom'

import { Spiner } from "./components";
import { REFRESH_TOKEN } from "./Graphql/mutations/setMutations";

export const MiddlewareContext = createContext();


export function useMiddlewareContext() {
    return useContext(MiddlewareContext);
}

export function MiddlewareProvider({ children }) {
    const [token, setToken] = useState(null);
    const refreshStroage = window.localStorage.getItem('refreshToken');
    const [refreshTokenMutation, { loading }] = useMutation(REFRESH_TOKEN);
    const setRefreshToken = (newRefreshToken) => localStorage.setItem('refreshToken', newRefreshToken);
    const refreshTokenApi = () => {
        if (!refreshStroage) {
            localStorage.removeItem('refreshToken')
            localStorage.removeItem('token')
            return
        };
        refreshTokenMutation({ variables: { refreshToken: refreshStroage } })
            .then(res => {
                const { authToken, refreshToken } = res.data.RefreshToken
                localStorage.setItem('refreshToken', JSON.stringify(refreshToken));
                localStorage.setItem('token', authToken)

                setToken(authToken);
                setRefreshToken(refreshToken);
                setTimeout(refreshTokenApi, 100 * 60 * 1000); //every 100 minutes
            }).catch(err => {
                console.log('loged out')
                localStorage.removeItem('refreshToken')
                localStorage.removeItem('token')
                return redirect('sign_in')

            });
    }
    useEffect(refreshTokenApi, []);

    if (loading) return <div style={{ height: '100vh' }}><Spiner /></div>;

    return <MiddlewareContext.Provider value={{ token, setToken, setRefreshToken }}>
        {children}
    </MiddlewareContext.Provider>

}